export const getIsToday = (testDateTime?: string) => {
  if (testDateTime === undefined) return false;

  const now = new Date();
  const testDateTimeDate = new Date(testDateTime);

  return (
    now.getFullYear() === testDateTimeDate.getFullYear() &&
    now.getMonth() === testDateTimeDate.getMonth() &&
    now.getDate() === testDateTimeDate.getDate()
  );
};
